import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
	Text1Directive,
	Text2Directive,
	Text3Directive,
	Text4Directive,
	Text5Directive,
	TextLight1Directive,
	TextLight2Directive
} from './basic/text.js';
import { AddHtmlLinksPipe } from './manipulation/add-html-links.pipe.js';
import { LineClampDirective } from './manipulation/line-clamp.directive.js';
import { ReplaceEmojisPipe } from './manipulation/replace-emojis.pipe.js';
import { TextToHtmlPipe } from './manipulation/text-to-html.pipe.js';
import { WordBreakDirective } from './manipulation/word-break.directive.js';
import { ShortenTextComponent } from './shorten/shorten-text.component.js';

@NgModule({
	imports: [CommonModule],
	declarations: [
		Text1Directive,
		Text2Directive,
		Text3Directive,
		Text4Directive,
		Text5Directive,
		LineClampDirective,
		WordBreakDirective,
		ShortenTextComponent,
		AddHtmlLinksPipe,
		TextToHtmlPipe,
		ReplaceEmojisPipe,
		TextLight1Directive,
		TextLight2Directive
	],
	exports: [
		Text1Directive,
		Text2Directive,
		Text3Directive,
		Text4Directive,
		Text5Directive,
		LineClampDirective,
		WordBreakDirective,
		ShortenTextComponent,
		AddHtmlLinksPipe,
		TextToHtmlPipe,
		ReplaceEmojisPipe,
		TextLight1Directive,
		TextLight2Directive
	]
})
export class TypographyModule {}
